import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Entry } from 'contentful';
import { MetaService } from '../../services/meta/meta.service';

@Component({
  selector: 'app-checkout-pay',
  templateUrl: './checkout-pay.component.html',
  styleUrls: ['./checkout-pay.component.scss']
})
export class CheckoutPayComponent implements OnInit {
  public content: Entry<any> | undefined;

  constructor(activatedRoute: ActivatedRoute, meta: MetaService) {
    this.content = activatedRoute.snapshot.data.content;
    if (this.content && this.content.fields.seo) {
      meta.updateMetaTags(this.content.fields.seo);
    }
  }

  ngOnInit() {}
}
